import type { EmailLogGroupKey } from "./messaging";

export const eventResultsKeys = {
  all: ["eventResults"] as const,
  detail: (eventId: string | undefined) => ["eventResults", eventId] as const,
  summaries: ["event-results-summary"] as const,
  summary: (quizrunId: number) => ["event-results-summary", quizrunId] as const,
};

export const eventPaymentsKeys = {
  all: ["eventPayments"] as const,
  detail: (quizrunId: number | null, participationIds: readonly number[]) =>
    ["eventPayments", quizrunId, participationIds] as const,
};

export const participationPaymentKeys = {
  all: ["participationPayment"] as const,
};

export const locationPaymentKeys = {
  all: ["locationPayment"] as const,
  list: ["locationPayment", "list"] as const,
  event: (eventId: number) => ["locationPayment", "event", eventId] as const,
};

export const paymentsKeys = {
  all: ["payments"] as const,
  list: ["payments", "all"] as const,
  targetsAll: ["paymentTargets"] as const,
  targets: (eventId: number | null) => ["paymentTargets", eventId] as const,
  targetSearch: (query: string) => ["paymentTargets", "search", query] as const,
  financeTerms: ["payments", "financeTerms"] as const,
  hostTransfers: ["payments", "hostTransfers"] as const,
  hostsByLocation: ["payments", "hostsByLocation"] as const,
  eventOurSharePctAll: ["eventOurSharePct"] as const,
  eventOurSharePct: (eventIds: readonly number[]) =>
    ["eventOurSharePct", eventIds] as const,
};

export const quizrunKeys = {
  list: ["quizruns"] as const,
  detail: (quizrunId: number | null) => ["quizrun", quizrunId] as const,
};

export const promoCodeKeys = {
  all: ["promoCodes"] as const,
  list: ["promoCodes", "all"] as const,
};

export const trackKeys = {
  quizrunMembers: (quizrunId: number) =>
    ["quizrunTrackMembers", quizrunId] as const,
  quizrunMembersFor: (
    quizrunId: number | null,
    personId: number | null,
    isAdmin: boolean,
    authorizationScope: readonly number[],
  ) =>
    [
      "quizrunTrackMembers",
      quizrunId,
      personId,
      isAdmin,
      authorizationScope,
    ] as const,
  trackableQuizruns: (
    personId: number | null,
    isAdmin: boolean,
    authorizationScope: readonly number[],
  ) => ["trackableQuizruns", personId, isAdmin, authorizationScope] as const,
};

export const statsKeys = {
  hero: ["hero-stats"] as const,
  heroPartnership: ["hero-stats-partnership"] as const,
  geography: ["geography-stats"] as const,
};

export const adminKeys = {
  people: ["admin-manage-people"] as const,
  teams: ["admin-manage-teams"] as const,
};

export const messagingKeys = {
  logRecipients: (group: EmailLogGroupKey) =>
    ["messaging", "logRecipients", group] as const,
};
